import * as React from "react";
import theme from "../../themes/mdc-theme";

function AddIconLarge() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={22}
      viewBox="0 0 31 33"
    >
      <path
        id="Icon_ionic-md-add"
        data-name="Icon ionic-md-add"
        d="M37.75,25.45H24.317v14.3H20.183V25.45H6.75v-4.4H20.183V6.75h4.133v14.3H37.75Z"
        transform="translate(-6.75 -6.75)"
        fill={theme.palette.MDCColors.black}
      />
    </svg>
  );
}

export default AddIconLarge;
